import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  ELegitCheckTypeSortField,
  ILegitCheckType,
  PLegitCheckTypeFilter,
} from "src/core/legitCheckType/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface ILegitCheckTypeState {
  legitCheckTypes: ILegitCheckType[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: ILegitCheckTypeState = {
  legitCheckTypes: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "legit-check-type/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "legit-check-type/FETCH_SUCCEEDED";
const FETCH_FAILED = "legit-check-type/FETCH_FAILED";
const POLLING_START_REQUESTED = "legit-check-type/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "legit-check-type/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: ILegitCheckType[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PLegitCheckTypeFilter;
    pagination: IPagination;
    sorts: ISort<ELegitCheckTypeSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<ILegitCheckTypeState, TActions> = (
  state = initialState,
  action
) => {
  return produce<ILegitCheckTypeState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.legitCheckTypes = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
